import { FC } from 'react'
import {
  DetailFeature,
  DetailFeatures,
  DetailField,
  DetailFields,
  DetailFooter,
  DetailHeader,
  DetailPanel,
} from 'app/components'
import { ExameView } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  data?: ExameView
  isLoading?: boolean
}

export const ExameExpandedRow: FC<Props> = ({ data, isLoading }) => {
  const { t } = useT()
  if (!isLoading && !data) return null

  const criadorNome = data?.criador
    ? `${data.criador.primeiroNome ?? ''} ${data.criador.sobreNome ?? ''}`.trim()
    : ''

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes do exame…'>
      {data && (
        <>
          <DetailHeader
            title={data.nome}
            meta={[data.codigo && `Cód. ${data.codigo}`, data.tipo]}
          />
          <DetailFields>
            <DetailField
              label={t('cols.descricao')}
              value={data.descricao}
              emptyLabel='Não informada'
              wide
            />
          </DetailFields>
          <DetailFeatures label='Características'>
            <DetailFeature label={t('apac.label')} active={data.apac} />
          </DetailFeatures>
          {criadorNome && (
            <DetailFooter>
              Cadastrado por <strong>{criadorNome}</strong>
            </DetailFooter>
          )}
        </>
      )}
    </DetailPanel>
  )
}
